import React, { useEffect, useState } from "react";

// internal imports
import "./paymentMethods.scss";
import ApplePayButton from "../applePayButton/applePayButton";
import { RootState } from "../../store/reducers";
import { actionCreators } from "../../store";
import { getApplePayToken } from "../../helper/applePay";
import GoSellEle from "../GoSell";
//images
import knetSmall from "../../assets/images/knet.png";
import credit from "../../assets/images/credit.png";

//external imports
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation, withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
// Materail ui
import Button from "@mui/material/Button";
import { Tab, Tabs, TabsList } from "@mui/base";
import { CircularProgress, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { erase, getCookie, setCookie } from "../../helper/cookieFunction";

declare global {
  interface Window {
    ApplePaySession: any; // Assuming you're not specifying a specific type for ApplePaySession
  }
}
const PaymentMethods = (props: any) => {
  const { handleCheckoutFunc, paymentMethod, setPaymentMethod, freezScreen, childRef, setTapId, setButtonLoading,goToAuth, buttonLoding = false, setCardDetails, invoice_total=null, otpIsRequired=false } = props;
  const navigate = useNavigate();
  const { slug } = useParams();
  const state = useSelector((state: RootState) => state.appReducer);
  const stateapi = useSelector((state: RootState) => state.apiReducer);

  const { paymentMethodPopUp, langValue, pendingCheckout, loginValues, loginModal } = state;
  const dispatch = useDispatch();
  let ApplePaySession: any;
  if (typeof window !== "undefined" && "ApplePaySession" in window) {
    ApplePaySession = (window as any).ApplePaySession;
  }
  const {setPaymentMethodPopUp,freezScreenState,alertMessageState,setBookingForm,setCart,setAuthToken,userInfoState,setPendingCheckout} = bindActionCreators(actionCreators, dispatch);
  const { t } = useTranslation();
  const [showAppleBtn, setShowAppleBtn] = useState(false);
  const payments = ["knet", "card", "wallet", "applePay", "cash"];
  const tapStatus = true;
  const hasGuestContact = () =>
    !!(loginValues?.fullName?.trim() && loginValues?.phoneNumber);

  const needsLogin = () => {
    if (otpIsRequired) {
      return !getCookie("tokenAuth") && !getCookie("Profile");
    }
    return !hasGuestContact();
  };

  const handleTabChange = (event: any, newValue: any) => {
    const nextValue = paymentMethod === newValue ? null : newValue;
    setPaymentMethod(nextValue);
    if (nextValue && needsLogin()) {
      goToAuth(false);
    }
  };

  const handleCloseAll = () => {
    setPaymentMethodPopUp(false);
  };
  const urlPart = "https://booking.enabill.com/enabill-main";

  console.log( {
    paymentMethod: paymentMethod,
    checkPaymentSource: "apple_pay",
    total: invoice_total ? invoice_total : state?.bookingTotal?.reservationFee,
    data: invoice_total ? invoice_total : state?.bookingTotal,
    invocieData: invoice_total
  },'checkoutData')
  const handlCheckoutWithApplePay = () => {
    freezScreenState(true);
    setPaymentMethod("apple_pay");
    let checkoutData = {
      paymentMethod: paymentMethod,
      checkPaymentSource: "apple_pay",
      total: invoice_total ? invoice_total : state?.bookingTotal?.reservationFee,
    };
    if (needsLogin()) {
      goToAuth(true);
      return;
    }
    getApplePayToken(
      state,
      checkoutData,
      ApplePaySession,
      handleCloseAll,
      freezScreenState,
      alertMessageState,
      setBookingForm,
      setCart,
      navigate,
      slug,
      goToAuth,
      otpIsRequired
    );
  
    // if (window.location.href.includes(urlPart)) {
    //   alert(' getApplePayToken -- Start')
    // }
  };
  useEffect(() => {
    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      setShowAppleBtn(true);
    }
  }, []);

  useEffect(() => {
    if (!pendingCheckout || paymentMethod !== "apple_pay" || loginModal) return;
    const ready = otpIsRequired
      ? getCookie("tokenAuth") && getCookie("Profile")
      : hasGuestContact();
    if (!ready) return;
    setPendingCheckout(false);
    getApplePayToken(
      state,
      {
        paymentMethod: paymentMethod,
        checkPaymentSource: "apple_pay",
        total: invoice_total ? invoice_total : state?.bookingTotal?.reservationFee,
      },
      ApplePaySession,
      handleCloseAll,
      freezScreenState,
      alertMessageState,
      setBookingForm,
      setCart,
      navigate,
      slug,
      goToAuth,
      otpIsRequired
    );
  }, [pendingCheckout, loginValues, state.authToken, loginModal]);

  return (
    <React.Fragment>
      <div
        id="mySidenav"
        className={`paymentMethodsl1  py-3 offset-sm-00 col-12 offset-lg-33 col-md-6
        ${langValue === "ar" ? "paymentMethodsl1Arabic" : ""}`}
      >
        <Dialog
          open={paymentMethodPopUp}
          keepMounted
          disableEnforceFocus
          disableAutoFocus
          onClick={handleCloseAll}
        />
        <span className="flex-center-between">
          <h3 className="d-flex px-4 my-3">{t("checkOut.Pay-With")}</h3>
          <IconButton
            className="d-flex  my-3 mx-4 "
            onClick={() => setPaymentMethodPopUp(false)}
          >
            <CloseIcon />
          </IconButton>
        </span>
        {/* <button onClick={handlCheckoutWithApplePay}>apple</button> */}
        {(showAppleBtn) && (
          <div className="px-4">
            <ApplePayButton
              handlCheckoutWithApplePay={handlCheckoutWithApplePay}
              handleCloseAll={handleCloseAll}
            />
            <p className="text-center divider familyPoppins600 mb-0 py-3 text-capitalize ">
              <span>
                {" "}
                <div className="circleDiv d-flex justify-content-center align-items-center">
                  {t("Login.OR")}
                </div>{" "}
              </span>
            </p>
          </div>
        )}

        <div className="paymentMethod px-3 tabNavigation">
        <Tabs value={false} onChange={handleTabChange}  >
            <TabsList className="tabListCustomized">
              {payments.includes("wallets") && (
                <Tab
                  className="customTabs"
                  disabled={tapStatus}
                  value={`${paymentMethod == `wallet` ? '' :"wallet"}`}

                >
                  <img className="mb-1" 
                  //src={enabill} 
                  alt="enabill" />
                  <p className="m-0">{t("checkOut.Wallet")}</p>
                </Tab>
              )}
              {payments.includes("knet") && (
                <Tab
                  className={`customTabs ${paymentMethod == 'knet' ? `base--selected` : ''} `}
                  value="knet"
                  

                // disabled={tapStatus}
                >
                  <img className="mb-1" src={knetSmall} alt="knet" />
                  <p
                    className="m-0">{t("checkOut.Knet")}</p>
                </Tab>
              )}

              {payments.includes("card") && (
                <Tab
                className={`customTabs ${paymentMethod == 'card' ? `base--selected` : ''} `}
                value="card"
                >
                  <img
                    className="mb-1"
                    src={credit}
                    alt="credit"
                    width={30}
                    height={30}
                  />
                  <p className="m-0">{t("checkOut.Credit-Card")}</p>
                </Tab>
              )}
              {
                payments.includes("cashable") && (
                  <Tab 
                  className={`customTabs ${paymentMethod == 'cash' ? `base--selected` : ''} `}

                    value="cash"
                  >
                    <img
                      className="mb-1"
                      // src={simpleCash}
                      alt="cash"
                      width={30}
                      height={30}
                    />
                    <p className="m-0">{t("checkOut.in-store")}</p>
                  </Tab>
                )
              }
            </TabsList>
          </Tabs>
        </div>

        {paymentMethod === "card" && (
          <React.Fragment>
            <div className="col-12">
              <GoSellEle
                setCardDetails={setCardDetails}
                ref={childRef}
                setTapId={setTapId}
                status={"checkout"}
                paymentMethod={paymentMethod}
                setButtonLoading={setButtonLoading}
              />
            </div>
            {/* {
              // loggedIn && payments.includes("save_card") &&
              <div
                className="d-flex mx-2 align-items-center save_card_checkbox"
                // onClick={handleChangeSaveCard}
              >
                <Checkbox
                  color="primary"
                  inputProps={{ "aria-label": "checkbox with default color" }}
                  // checked={checkedSaveCard}
                />
                <p className="my-0">{t("Forms.Save-card")}</p>
              </div>
            } */}
          </React.Fragment>
        )}

        <span
          id="process-btn"
          className="row col-12 m-0 d-flex justify-content-center"
        >
          <Button
            className={`process-btn col-12 familysora700 ${
              paymentMethod === "" ? "disabledCheckoutBtn" : "btn-main"
            } col-10  text-capitalize align-item-center`}
            disabled={paymentMethod === "" || freezScreen || buttonLoding}
            onClick={() => handleCheckoutFunc()}
            // onClick={() => setPaymentMethodPopUp(false)}
          >
            {buttonLoding ? <CircularProgress size={20} style={{ color: '#fff' }} /> : t("navBar.pay")}
          </Button>
        </span>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(PaymentMethods);
